import type { MyProfileReadonly } from "@/lib/types";
import { careerPillClass } from "@/components/feature/MemberCard";

function Row({ label, value }: { label: string; value?: string }) {
  const v = String(value ?? "").trim();
  return (
    <div className="flex gap-3 text-sm">
      <dt className="w-20 shrink-0 text-foreground-500">{label}</dt>
      <dd className="text-foreground-900">
        {v || <span className="text-foreground-400">미입력</span>}
      </dd>
    </div>
  );
}

// 회원이 수정할 수 없는 명부 기준 항목 (읽기 전용)
export default function ReadonlyCard({ data }: { data: MyProfileReadonly }) {
  const careers = data.career ?? [];
  return (
    <section className="rounded-xl border border-background-200 bg-background-100 p-5 md:p-6">
      <div className="mb-4 flex items-center gap-3">
        <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-500">
          <i className="ri-lock-line" aria-hidden="true"></i>
        </span>
        <div>
          <h2 className="font-heading text-base font-bold text-foreground-900">
            클럽 명부 정보
          </h2>
          <p className="text-xs text-foreground-500">
            명부 기준 항목은 회원이 직접 수정할 수 없습니다.
          </p>
        </div>
      </div>

      <dl className="space-y-3">
        <Row label="성명" value={data.name} />
        <Row label="아호" value={data.aho} />
        <Row label="RI번호" value={data.ri_no} />
        <Row label="생일" value={data.birth} />
        <Row label="입회일" value={data.join_date} />
        <Row label="클럽직책" value={data.club_role} />
      </dl>

      <div className="mt-5">
        <p className="mb-2 text-xs font-semibold text-foreground-500">로타리 경력</p>
        {careers.length > 0 ? (
          <div className="flex flex-col items-start gap-1.5">
            {careers.map((c, i) => (
              <span
                key={i}
                className={`inline-block max-w-full whitespace-normal break-keep rounded-md px-2.5 py-1 text-[12.5px] leading-[1.35] ${careerPillClass(c)}`}
              >
                {c}
              </span>
            ))}
          </div>
        ) : (
          <p className="text-sm text-foreground-400">등록된 경력이 없습니다.</p>
        )}
      </div>

      <p className="mt-5 rounded-lg bg-background-200/70 px-4 py-3 text-xs leading-relaxed text-foreground-600">
        이 항목은 클럽 명부 기준입니다. 수정이 필요하면 클럽 총무에게 문의해 주세요.
      </p>
    </section>
  );
}